import { ChevronDown } from "lucide-react";
import { useState } from "react";
import type { ReactNode } from 'react';

export const Accordion = ({
  title,
  children,
  icon,
  className = ''
}: {
  title: ReactNode,
  children: ReactNode,
  icon?: ReactNode,
  className?: string
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`bg-white/5 border border-gray-700/50 rounded-lg ${className}`}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex justify-between items-center p-4 text-left text-neutral-light focus:outline-none"
      >
        {/* Group icon and title together */}
        <div className="flex items-center gap-3">
          <span className="font-medium">{title}</span>
          {icon && <span>{icon}</span>}
        </div>
        <ChevronDown className={`w-5 h-5 transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      {isOpen && (
        <div className="p-4 border-t border-gray-700/50">
          {children}
        </div>
      )}
    </div>
  );
};
